<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold pt-2" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('heatTransferCoefficient', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionHeatTransferCoefficient',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'U-Wert [W/(m<sup>2</sup>K)]',
      items: [
        { title: '≤ 0,11', value: 0.11 },
        { title: '≤ 0,12', value: 0.12 },
        { title: '≤ 0,13', value: 0.13 },
        { title: '≤ 0,14', value: 0.14 },
        { title: '≤ 0,15', value: 0.15 },
        { title: '≤ 0,16', value: 0.16 },
        { title: '≤ 0,18', value: 0.18 },
        { title: '≤ 0,19', value: 0.19 },
        { title: '≤ 0,20', value: 0.2 },
        { title: '≤ 0,21', value: 0.21 },
        { title: '≤ 0,23', value: 0.23 },
        { title: '≤ 0,24', value: 0.24 },
        { title: '≤ 0,27', value: 0.27 },
        { title: '≤ 0,38', value: 0.38 },
        { title: '≤ 0,45', value: 0.45 },
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('heatTransferCoefficient', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('<sup>').join('').split('</sup>').join('') + ' ' + title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'heatTransferCoefficient',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
